import { ReactNode, useEffect } from 'react';
import { useIsClientLocked } from './useIsClientLocked.hook';

type IsClientLockedProps = {
  render: (isClientLocked: boolean) => ReactNode,
  onChange?: (isClientLocked: boolean) => void,
}
export const IsClientLocked = ({ render, onChange }: IsClientLockedProps) => {
  const isClientLocked = useIsClientLocked();

  useEffect(() => {
    onChange?.(isClientLocked);
  }, [isClientLocked, onChange]);

  return render(isClientLocked);
};
